import { ReactNode, memo } from 'react';

import {
  NameCellContainer,
  NameCellAvatar,
  NameCellText,
} from './name-cell.style';

export type NameCellProps = {
  avatar: ReactNode;
  name: ReactNode;
  additionalInfo?: ReactNode;
  padding?: number;
};

const NameCell = memo(
  ({ avatar, name, additionalInfo, padding = 4 }: NameCellProps) => (
    <NameCellContainer padding={padding}>
      <NameCellAvatar>{avatar}</NameCellAvatar>
      <NameCellText>
        <div>{name}</div>
        {additionalInfo && (
          <div>
            <small>{additionalInfo}</small>
          </div>
        )}
      </NameCellText>
    </NameCellContainer>
  )
);

// eslint-disable-next-line import/no-default-export
export default NameCell;
